import type { TypeRecherche } from '@/features/application/types'
import type { LocationQuery } from 'vue-router'
import type { PagedRequest } from './storeRechercheBuilder'

export type RechercheRoutingService<T extends object> = {
  loadStoreFromLocationQuery: (query: LocationQuery) => Promise<boolean>
  loadPageWithPagedRequest: (request: PagedRequest<T>) => void
}

export type UseRechercheRoutingService<T extends object> = () => RechercheRoutingService<T>

const services: { [key in TypeRecherche]?: UseRechercheRoutingService<object> } = {}

export function provideLoadRechercheService(type: TypeRecherche, service: UseRechercheRoutingService<object>) {
  services[type] = service
}

export function injectLoadRechercheService(type: TypeRecherche): RechercheRoutingService<object> {
  return services[type]!()
}

